import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { antiForgeryFormOptions } from '../common/antiForgery';
import { getReturnUrl } from '../common/returnUrl';
import { SignUpView } from './signUpView';
import { SignUpFormValues } from '../common/interfaces';
import { SignUpSuccess } from './signUpSuccess';
import { signUp } from '../data/endpointServices';

export const SignUp = () => {
    const [signedUp, setSignedUp] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState<string>('');
    const [acutalDate, setActualDate] = useState<string>('');
    const returnUrl = getReturnUrl();
    const antiForgeryOptions = antiForgeryFormOptions();
    const { errors: fieldsErrors, handleSubmit, register, watch } = useForm();
    const { t } = useTranslation();
    
    const submitSignUp = async(data: SignUpFormValues) => {
        setLoading(true);
        const dateOfBirth = dayjs(new Date(acutalDate)).endOf('month').format('YYYY-MM-DD');
        
        try {
            if (data) {
                const response = await signUp(
                    data.email, 
                    data.password, 
                    data.terms, 
                    dateOfBirth, 
                    returnUrl, 
                    antiForgeryOptions
                );

                if(response?.status === 200) {
                    setSignedUp(true);
                }
            }
        } catch (error) {
            if (error?.response?.data?.c === 400) {
                setServerError(error?.response?.data?.e);
            } else if (error?.response?.data?.c === 409) { 
                setServerError(t('signUpExistingUserError'));
            } else {
                setServerError(t('signUpSystemError'));
            }
        } finally {
            setLoading(false);
        }
    };

    return(
        <div>
            {!signedUp
                ? <SignUpView
                    submitSignUp={submitSignUp}
                    fieldsErrors={fieldsErrors}
                    handleSubmit={handleSubmit}
                    register={register}
                    watch={watch}
                    returnUrl={returnUrl === null ? '' : returnUrl}
                    loading={loading}
                    serverError={serverError}
                    setActualDate={setActualDate}
                />
                : <SignUpSuccess returnUrl={returnUrl === null ? '' : returnUrl} /> 
            }
        </div>
    );
};